import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var ritualSchema = {
    youtube_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'YouTube линк',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден линк към YouTube',
    }),
    products: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: true
        }),
        elementType: 'autocomplete',
        label: 'Продукти',
        value: [],
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден продукт',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    image_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'image',
        label: 'Aдрес картинка',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден адрес',
    }),
};
export default ritualSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/ritualSchema.ts
// module id = 442
// module chunks = 0